import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, Renderer, TemplateRef } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs/Subscription";
import { Producto } from '../../../models/producto';
import { PrecioAdicionalService } from '../../../services/precio-adicional.service';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { VentaDetalle } from '../../../models/venta_detalle';
import { PrecioVentaService } from '../../../services/precio-venta.service';
import { PrecioVenta } from '../../../models/precio-venta';

@Component({
  selector: 'app-precios-modal',
  templateUrl: './precios-modal.component.html',
  styleUrls: ['./precios-modal.component.css'],
  providers: [
	 BsModalService,
	 PrecioAdicionalService,
	 PrecioVentaService
  ]
})
export class PreciosModalComponent implements OnInit {
	//@Input() detalle: VentaDetalle;

	@Input() producto_id: String;
	@Input() descripcion: String;

	@Output() sendPrecio = new EventEmitter();
	public loading: boolean;
	public adicionales: Array<PrecioAdicional>;
	public adicional: PrecioAdicional;
	public selectedRow: Number;
	public precioVenta: PrecioVenta;

	constructor(
		public bsModalRef: BsModalRef,
		public precioService: PrecioAdicionalService,
		public productoPrecioService: PrecioVentaService,
	) { 
		this.loading = false;
		this.adicionales = [];
		this.adicional = new PrecioAdicional();
		this.precioVenta = new PrecioVenta();
	}

	ngOnInit() {
		this.getPrecios();
	}

	getPrecios() {
		this.loading = true;

		this.productoPrecioService.getById(this.producto_id).subscribe(
			res => {
				this.loading = true;
				this.precioVenta = res;

				this.precioService.getAll("?producto_id="+this.producto_id+"&embed=tipoprecio").subscribe(
					res => {
						this.loading = false;
		
						let precio_adicional = new PrecioAdicional();
						precio_adicional.valor = parseFloat(this.precioVenta.precio.toString());
						precio_adicional.tipoprecio.nombre = "PRECIO DE VENTA";
		
						this.adicionales = [];
						this.adicionales.push(precio_adicional);
		
						this.adicionales = this.adicionales.concat(res.data);
					},
					err => {
						this.loading = false;
					}
				);
			},
			err => {
				this.loading = false;
			}
		);
	}

	onSubmit(){
		//envía de objecto precio adicional
		this.sendPrecio.emit(this.adicional);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	openModal(modalAdd){

	}

	onSelectRow(precio, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de precio adicional
		this.adicional = precio;
	}

	onDBLClick(precio,i){
		this.onSelectRow(precio,i);
		this.onSubmit();
	}
	

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/precios-modal/precios-modal.component.ts